import { useTranslation } from "@/hooks/useTranslation";
import { useGetAccountLocale } from "@/hooks/useGetAccountLocale";

function formatDate(dateString: string, locale: string = "en-US"): string {
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export default function JoinedAtBadge({
  joinedAt,
}: {
  joinedAt: string | null;
}) {
  const t = useTranslation();
  const locale = useGetAccountLocale();

  if (joinedAt === null) {
    return null;
  }
  return (
    <div className="flex text-sm flex-row w-full items-center justify-end gap-2 mt-4">
      <span className="text-gray-400">{t.PROFILE_VIEW.LABELS.JOINED_ON}</span>
      <div className="flex flex-row gap-2 rounded-full text-zinc-300 bg-zinc-700 px-4 py-1 items-center shadow-[inset_0_2px_3px_rgba(0,0,0,0.5)]">
        {formatDate(joinedAt, locale.code)}
      </div>
    </div>
  );
}
